module.exports = __webpack_public_path__ + "img/设备图1@3x.8fe9b362.png";